/* 2026-09-27 product-funnel events to GA4 (experiment EXP-020).
   GA4 (G-2E4DYTLQ0E) is fed by Shopify's sandboxed Google pixel, which never sees events from the page, so the
   personalization events pushed to dataLayer since 2026-09-17 never reached GA4. This loads gtag on product pages
   with send_page_view:false (no extra page views; it reuses the site's first-party _ga / _ga_2E4DYTLQ0E cookies, so
   events join the same visitor and session) and sends only the funnel events below. New names on purpose, so the
   pixel's own add_to_cart is never double-counted. No personal data: never the recipient name, only booleans/timings.
     personalization_name_started      first character typed in the recipient-name field (from preview-cart-bar.js)
     personalization_preview_clicked   Preview tapped (from preview-cart-bar.js)
     personalization_preview_ready     preview image shown; preview_ms = time since the tap
     personalization_preview_slow      same, when it took more than 8 s
     personalization_preview_timeout   no preview image 25 s after the tap
     personalized_add_to_cart          Customer Canvas ADD TO CART (button.ps-finish) clicked
     preview_bar_view / preview_bar_add_to_cart / sticky_personalize_click   (from preview-cart-bar.js)
   Respects Shopify's analytics consent when the Customer Privacy API reports it.
   2026-10-08: also loads on /pages/promises (any page with [data-ps-ga4]) and accepts:
     ab_exposure {ab_test, ab_variant} + abnf_<a|b>_exposure/_name_started/_add_to_cart   EXP-022 name-first A/B (ps-ab-namefirst.js)
     promises_name_entered / promises_share {share_method} / promises_cta {cta}             /pages/promises
   String params are forwarded only for the keys in STR and only as short [a-z0-9_] codes (never names or free text).
   2026-10-19 EXP-075: also loads on daily devotionals (snippets/ps-devo-collections.liquid adds the script and
   [data-ps-ga4]) and accepts devo_cta_click {article_handle (post handle, [a-z0-9-]), position: end|inline|sticky}.
   window.psGa4Load() preloads gtag.js; psGa4Event(name, params, cb) calls cb once the hit is sent (or at once if not sent). */
(function () {
  if (!document.querySelector('#ps-product-interface, #ps-product-form, form[action*="/cart/add"], [data-ps-ga4]')) return;
  var ID = 'G-2E4DYTLQ0E';
  var ALLOWED = {
    personalization_name_started: 1, personalization_preview_clicked: 1, personalization_preview_ready: 1,
    personalization_preview_slow: 1, personalization_preview_timeout: 1, personalized_add_to_cart: 1,
    preview_bar_view: 1, preview_bar_add_to_cart: 1, sticky_personalize_click: 1,
    ab_exposure: 1, abnf_a_exposure: 1, abnf_b_exposure: 1, abnf_a_name_started: 1, abnf_b_name_started: 1,
    abnf_a_add_to_cart: 1, abnf_b_add_to_cart: 1,
    promises_name_entered: 1, promises_share: 1, promises_cta: 1,
    devo_cta_click: 1
  };
  var STR = { ab_test: 1, ab_variant: 1, share_method: 1, cta: 1, position: 1 };
  var HANDLE = { article_handle: 1 };   // public blog-post handles only
  var loaded = false;
  var sentOnce = {};

  function consentOk() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch (e) {}
    return true;
  }
  function load() {
    if (loaded) return;
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', ID, { send_page_view: false });
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + ID;
    document.head.appendChild(s);
  }
  function send(name, params, cb) {
    if (!ALLOWED[name] || !consentOk()) { if (typeof cb === 'function') cb(); return; }
    load();
    var p = { send_to: ID, page_path: window.location.pathname };
    Object.keys(params || {}).forEach(function (k) {
      var v = params[k];
      if (typeof v === 'number' || typeof v === 'boolean') p[k] = v;   // never forward free text
      else if (STR[k] && typeof v === 'string' && /^[a-z0-9_]{1,40}$/.test(v)) p[k] = v;
      else if (HANDLE[k] && typeof v === 'string' && /^[a-z0-9-]{1,100}$/.test(v)) p[k] = v;
    });
    if (typeof cb === 'function') { p.event_callback = cb; p.event_timeout = 1000; }
    try { window.gtag('event', name, p); } catch (e) {}
  }
  function once(name, params) { if (sentOnce[name]) return; sentOnce[name] = true; send(name, params); }
  window.psGa4Event = send;
  window.psGa4Load = function () { if (consentOk()) load(); };

  // Customer Canvas ADD TO CART (only visible after Preview).
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('#ps-product-interface .ps-finish, #ps-product-interface button.ps-finish');
    if (t) send('personalized_add_to_cart', {});
    var p = e.target && e.target.closest && e.target.closest('#ps-product-interface button.ps-preview, #ps-product-interface .ps-preview');
    if (p) timePreview();
  }, true);

  // Preview timing: from the tap until an image is visible in the preview lightbox.
  var timing = false;
  function timePreview() {
    if (timing) return;
    timing = true;
    var t0 = Date.now();
    var iv = setInterval(function () {
      var ms = Date.now() - t0;
      var img = document.querySelector('.ReactModal__Content--after-open img');
      if (img && img.complete && img.naturalWidth > 0) {
        clearInterval(iv); timing = false;
        send('personalization_preview_ready', { preview_ms: ms });
        if (ms > 8000) send('personalization_preview_slow', { preview_ms: ms });
      } else if (ms > 25000) {
        clearInterval(iv); timing = false;
        once('personalization_preview_timeout', { preview_ms: ms });
      }
    }, 250);
  }
})();
